export class PasswordDialog {
    constructor(private engine: PasswordEngine) {

    }

    BringToTop(): void {
        this.engine.BringToTop()
    }

    Show(width: number, height: number, message?: string, titleMessage?: string, lowerMessage?: string, mainTitleMessage?: string): void {
        this.Visible = true
        this.engine.Show(message,titleMessage,lowerMessage,mainTitleMessage)
        this.engine.Resize(width,height)
    }

    Hide(): void {
        this.Visible = false
        this.engine.Hide()
    }

    Resize(width: number, height: number): void {
        this.engine.Resize(width,height)
    }

    UpdateCallback(callback: PasswordCallback): void {
        this.engine.UpdateCallback(callback)
    }

    public Visible = false
}

export class WindowPasswordDialog implements PasswordEngine {
    constructor() {

    }

    BringToTop(): void {

    }

    Show(message?: string, titleMessage?: string, lowerMessage?: string, mainTitleMessage?: string): void {
        let password = message ? window.prompt(message, "") : window.prompt(`Enter your PIN:`, "")
        this.Callback(password)
    }

    Hide(): void {

    }

    Resize(width: number, height: number): void {

    }

    UpdateCallback(callback: PasswordCallback): void {
        this.Callback = callback
    }

    Callback: PasswordCallback
}

export interface PasswordEngine {
    BringToTop(): void
    Show(message?: string, titleMessage?: string, lowerMessage?: string, mainTitleMessage?: string): void
    Hide(): void
    Resize(width: number, height: number): void
    UpdateCallback(callback: PasswordCallback): void
    Callback: PasswordCallback
}

export type PasswordCallback = (enteredPassword: string) => void